import React from 'react'
import PropTypes from 'prop-types'

import { Chip, Avatar, useTheme } from '@mui/material'
import { green } from '@mui/material/colors'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import HHDisplayMoney from '../HHDisplayMoney'

const AccountCreditChip = ({ creditCents = 0 }) => {
  const theme = useTheme()

  if (!creditCents) return null

  return (
    <Chip
      size="small"
      avatar={
        <Avatar sx={{ backgroundColor: green[500] }}>
          <CreditCardIcon sx={{ fontSize: 16, color: theme.palette.common.white }} />
        </Avatar>
      }
      variant="outlined"
      label={
        <>
          Credit: <HHDisplayMoney value={creditCents} />
        </>
      }
      sx={{
        fontWeight: 600,
        border: '1px solid',
        borderColor: green[500],
        backgroundColor: green[50],
        color: green[700],
      }}
    />
  )
}

AccountCreditChip.propTypes = {
  creditCents: PropTypes.number,
}

export default AccountCreditChip
